module.exports = __webpack_public_path__ + "img/devbox34.9dcb07b0.png";